export const getClosestDate = (dates) => {
    if(!dates || !dates.length)
        return ''

    const currentDate = new Date();
    const today = currentDate.toISOString().split('T')[0];
    
    const sortedDates = dates.sort();
    
    // Recherche de la date d'aujourd'hui
    if (dates.includes(today)) {
        return today;
    }
    
    // Recherche de la date supérieure la plus proche
    for (let i = 0; i < sortedDates.length; i++) {
        if (sortedDates[i] > today) {
        return sortedDates[i];
        }
    }
    
    // Aucune date supérieure, retourne la date inférieure la plus proche (dernière date du tableau)
    return sortedDates[sortedDates.length - 1];
}

export const convertTimeToSeconds = (time) => {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return (hours * 3600) + (minutes * 60) + seconds;
};

export const convertSecondsToTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
};


export const isHhhMmSsInput = (gameFactModel) =>
  gameFactModel?.type?.format === 'time' &&
  gameFactModel?.type?.unit === 'ss' &&
  gameFactModel?.type?.inputFormat === 'hhh:mm:ss';

const convertHhhMmSsToSeconds = (value) => {
  if (!value) return 0;

  const match = String(value).match(/^(\d{1,3}):([0-5]\d):([0-5]\d)$/);

  if (!match) {
    return undefined;
  }

  const [, hours, minutes, seconds] = match;

  return Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
};

export const convertSecondsToHhhMmSs = (value) => {
  const totalSeconds = Number(value || 0);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    String(hours).padStart(3, '0'),
    String(minutes).padStart(2, '0'),
    String(seconds).padStart(2, '0')
  ].join(':');
};

export const convertGameFactTimeToSeconds = (gameFactModel, value) => {
  if (isHhhMmSsInput(gameFactModel)) {
    return convertHhhMmSsToSeconds(value);
  }

  if (gameFactModel?.type?.format === 'time' && gameFactModel?.type?.unit === 'ss') {
    return convertTimeToSeconds(value);
  }

  return value;
};

export const convertSecondsToGameFactTime = (gameFactModel, value) => {
  if (isHhhMmSsInput(gameFactModel)) {
    return convertSecondsToHhhMmSs(value);
  }

  if (gameFactModel?.type?.format === 'time') {
    return convertSecondsToTime(value);
  }

  return value;
};